import FollowUsConfig from "./FollowUsConfig";
import type { Store } from "./Store";

export class LandingPageConfig {
  public offerLpTemplateId: number;
  public lpCode: string;
  public is2fa: boolean;
  public mobileNumber: string;
  public mobileVirtualNumber: string;
  public registrationRequestUUID: string;
  public storeLanguageCode: string;
  public countryCode: string;
  public languageCode: string;
  public lpHeader1: string;
  public lpHeader2: string;
  public lpHeader3: string;
  public lpHeader4: string;
  public merchantName: string;
  public merchantWebSite: string;
  public merchantFullAddress: string;
  public supportEmail: string;
  public logoUrl: string;
  public isFacebookSignup: boolean;
  public isGoogleSignup: boolean;
  public googleTagId: string;
  public stylesheet: string;
  public oaAuthFirstName: string;
  public oaAuthLastName: string;
  public oaAuthEmail: string;
  public tncTermClass: string;
  public tncTermText: string;
  public tncTermUrl: string;
  public prvTermClass: string;
  public prvTermText: string;
  public prvTermUrl: string;
  public ttcTermClass: string;
  public ttcTermText: string;
  public ttcTermUrl: string;
  public otcTermClass: string;
  public otcTermText: string;
  public otcTermUrl: string;

  public hidesFirstName?: boolean;
  public hidesLastName?: boolean;
  public hidesEmail?: boolean;
  public showsPostalCode: boolean;
  public showsDOB: boolean;
  public showsStoreSelector: boolean;
  public showsUSTerm: boolean;
  public consentAge?: number;
  public storeList?: Store[];

  public followUs: FollowUsConfig[];

  public constructor(obj: any) {
    this.offerLpTemplateId = obj.offerLpTemplateId;
    this.is2fa = !!obj.is2fa;
    this.mobileNumber = obj.mobileNumber;
    this.mobileVirtualNumber = obj.mobileVirtualNumber;
    this.registrationRequestUUID = obj.registrationRequestUUID;
    this.storeLanguageCode = obj.storeLanguageCode;
    this.countryCode = obj.countryCode;
    this.languageCode = obj.languageCode;
    this.lpHeader1 = obj.lpHeader1;
    this.lpHeader2 = obj.lpHeader2;
    this.lpHeader3 = obj.lpHeader3;
    this.lpHeader4 = obj.lpHeader4;
    this.merchantName = obj.merchantName;
    this.merchantWebSite = obj.merchantWebSite;
    this.merchantFullAddress = obj.merchantFullAddress;
    this.supportEmail = obj.supportEmail;
    this.logoUrl = obj.logoUrl;
    this.isFacebookSignup = obj.isFacebookSignup;
    this.isGoogleSignup = obj.isGoogleSignup;
    this.googleTagId = obj.googleTagId;

    this.oaAuthFirstName = obj.oaAuthFirstName;
    this.oaAuthLastName = obj.oaAuthLastName;
    this.oaAuthEmail = obj.oaAuthEmail;

    this.tncTermClass = obj.tncTermClass;
    this.tncTermText = obj.tncTermText;
    this.tncTermUrl = obj.tncTermUrl;
    this.prvTermClass = obj.prvTermClass;
    this.prvTermText = obj.prvTermText;
    this.prvTermUrl = obj.prvTermUrl;
    this.ttcTermClass = obj.ttcTermClass;
    this.ttcTermText = obj.ttcTermText;
    this.ttcTermUrl = obj.ttcTermUrl;
    this.otcTermClass = obj.otcTermClass;
    this.otcTermText = obj.otcTermText;
    this.otcTermUrl = obj.otcTermUrl;
    this.hidesFirstName = obj.hidesFirstName;
    this.hidesLastName = obj.hidesLastName;
    this.hidesEmail = obj.hidesEmail || this.offerLpTemplateId === 7;
    this.showsPostalCode =
      this.offerLpTemplateId === 2 || this.offerLpTemplateId === 3;
    this.showsDOB = this.offerLpTemplateId === 2;
    this.showsStoreSelector =
      obj.showsStoreSelector ||
      this.offerLpTemplateId === 8 ||
      this.offerLpTemplateId === 9;
    this.showsUSTerm =
      obj.showsUSTerm ||
      this.offerLpTemplateId === 4 ||
      this.offerLpTemplateId === 9;
    this.consentAge = obj.consentAge;
    this.storeList = obj.storeList;
    if (this.offerLpTemplateId === 3) {
      this.stylesheet = `
             @import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
             :not(.fab) { font-family: 'Montserrat', sans-serif !important; }
             `;
    }

    this.followUs = [];
    if (obj.followUsId1 && obj.followUsUrl1 && obj.followUsLogoUrl1) {
      this.followUs.push(
        new FollowUsConfig(
          obj.followUsId1,
          obj.followUsUrl1,
          obj.followUsLogoUrl1,
        ),
      );
    }
    if (obj.followUsId2 && obj.followUsUrl2 && obj.followUsLogoUrl2) {
      this.followUs.push(
        new FollowUsConfig(
          obj.followUsId2,
          obj.followUsUrl2,
          obj.followUsLogoUrl2,
        ),
      );
    }
  }
}

export type LandingPageConfigOptions = Partial<LandingPageConfig>;

/**
 * @deprecated
 */
export default LandingPageConfig;
